import { FormControlBase } from "../dynamic-form-controls/form-control-base";

export class CommonUtils {
  static generateUniqueId () {
      return Math.random().toString(36).substring(2);
  }

  static mapValues(target: any, source: any) {
    Object.keys(source).map(k => {
      if (source[k] instanceof Date) {
        if (source[k] as any != 'Invalid Date') {
          target[k] = source[k].toISOString();
        }
      }
      else {
        target[k] = source[k];
      }
    });
  }

  static copyObj(source: any) {
    // OnPush: Make copy for changing object in InvoicePreviewComponent.
    let copyObj = Object.assign({}, source);
    return copyObj;
  }

  static replaceComma(numberStr: string) {
    if (!numberStr)
      return '';
    
    return (numberStr + '').replace(/,/g, '');
  }

  static mapFormValues(form: any, obj: any) {
    if (!obj) {
      return;
    }

    Object.keys(obj).map(k => {
      let control = form.controls[k];
      if (control) {
        let val = obj[k];
        // NaN
        if (val !== val) {
          val = '';
        }
        control.setValue(val);
      }
    });
  }

  static setControlsValue(controls: FormControlBase<any>[], obj: any) {
    if (!controls) {
      return;
    }

    controls.map(c => {
      c.setValue(obj[c.key]);
    });
  }

  static replaceAt(text: string, idx: number, replacement: string): string {
    return text.substr(0, idx) + replacement + text.substr(idx + replacement.length);
  }  

  static roundNumber(amount: number, precision: number) {
    return Math.round((amount + Number.EPSILON) * precision) / precision;
  }

  static floorNumber(amount: number, precision: number) {
    return Math.floor((amount + Number.EPSILON) * precision) / precision;
  }

  static ceilNumber(amount: number, precision: number) {
    return Math.ceil((amount + Number.EPSILON) * precision) / precision;
  }

  static isEmpty(val: any) {
    return val === '' || val === null || val === undefined;
  }

  static isNaNOrEmpty(val: any) {
    return isNaN(val) || this.isEmpty(val);
  }

  static toCamelCase(text: string) {
    return text.replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    }).replace(/\s+/g, '');
  }

  static roundToDecimalPlaces(amount: number, places: number) {
    let dp = 1;
    for (var i = 0; i < places; i++) {
      dp *= 10;
    }
    return Math.round(amount * dp) / dp;
  }

       /**
   * Gets the absolute path from the current router URL
   * Example: http://localhost:4200/loans/goals -> /loans/goals
   */
  static getAbsolutePath(absoluteUrl: string): string {
    return absoluteUrl.split('?')[0].split('#')[0];
  }

  /**
   * Gets the absolute path without query parameters or fragments
   * and optionally removes the base path
   */
  static getCleanAbsolutePath(absoluteUrl: string, removeBasePath?: string): string {
    const absolutePath = this.getAbsolutePath(absoluteUrl);
    
    if (removeBasePath && absolutePath.startsWith(removeBasePath)) {
      return absolutePath.substring(removeBasePath.length);
    }
    
    return absolutePath;
  }

   /**
   * Checks if the current path matches a specific route
   */
  static isCurrentPath(absoluteUrl: string, path: string): boolean {
    const currentPath = this.getAbsolutePath(absoluteUrl);
    return currentPath === path || currentPath.startsWith(`${path}/`);
  }
}
